
import {ScrollBoxOptions, Scrollbox} from '@colonist/pixi'
import {SectionBgView} from '../../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {UIGameEndTabButtonsView} from '../../../../shared/scripts/ui_game/ui_game_end_screen/GameEndTabButtonsView'
import {UIGameEndStatsController} from '../../../../shared/scripts/ui_game/ui_game_end_screen/UIGameEndStatsController'
import {SectionView} from '../../../../shared/scripts/ui_canvas_engine/SectionView'
import {UIGameEndChartView} from '../../../../shared/scripts/ui_game/ui_game_end_screen/UIGameEndChartView'
import {uiGameManager} from '../../../../shared/scripts/EntryShared'
import {GameModeTranslationKeyContext} from '@colonist/i18n'

export class UIMGameEndStatsControllerBottom extends UIGameEndStatsController {
    private chartScrollbox: Scrollbox

    protected buildTabs(gameModeTranslationKeyContext: GameModeTranslationKeyContext) {
        this.tabButtonsView = new UIGameEndTabButtonsView(0, 0, this.container.width, this.itemSize, 3, this.container, this, gameModeTranslationKeyContext)
        this.tabButtonsView.createDiceStatsTab()
        this.tabButtonsView.createResourceCardStatsTab()
        this.tabButtonsView.createDevCardStatsTab()
        this.createCharts()
    }

    private createCharts() {
        const y = this.tabButtonsView.height
        const w = this.container.width
        const h = this.container.height - y

        const scrollBoxContainer = new SectionView(0, y, w, h, this.container)
        const scrollBoxOptions: ScrollBoxOptions = {
            boxWidth: w,
            boxHeight: h,
            overflowY: 'hidden',
            scrollbarSize: this.itemSize / 10,
            scrollbarBackgroundAlpha: 0,
            events: uiGameManager.canvasController.app.renderer.events,
        }
        this.chartScrollbox = new Scrollbox(scrollBoxOptions)
        scrollBoxContainer.addChild(this.chartScrollbox)

        this.chartContainer = new SectionBgView(0, 0, w, h, this.chartScrollbox.content)
        this.createChartTabs()

        this.chartScrollbox.content.on('pointerdown', (e) => {
            this.uiGameManager.toolTipController.closeTip()
        })
    }

    override showActiveView() {
        super.showActiveView()
        this.updateChartScrollbox()
    }

    private updateChartScrollbox() {
        if(this.chartScrollbox.content.width < this.chartScrollbox.boxWidth) {
            this.chartScrollbox.overflowX = 'hidden'
            this.chartScrollbox.content.x = (this.chartScrollbox.boxWidth - this.chartContainer.width) / 2
            this.chartScrollbox.content.decelerate({friction: 1})
            return
        }
        this.chartScrollbox.overflowX = 'scroll'
        this.chartScrollbox.content.decelerate({friction: 0.95})
        if(this.activeTab.container instanceof UIGameEndChartView) this.activeTab.container.addEmptyColumn()
    }
}
